import { MenuItemProps } from 'features/footer/components/MenuItem';
import { generateExternalMenuItems } from 'features/footer/utils';
import { tenantConfigurationAtom } from 'libs/recoil/atom';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { useFooterFeatureMenus } from './useFooterFeatureMenus';

export const useFooterMenuItems = (): MenuItemProps[] => {
  const tenantConfiguration = useRecoilValue(tenantConfigurationAtom);
  const footerFeatureMenus = useFooterFeatureMenus();

  return useMemo(() => {
    const externalMenuItems = generateExternalMenuItems(
      tenantConfiguration.external_links
    );
    return [...externalMenuItems, ...footerFeatureMenus];
  }, [tenantConfiguration.external_links, footerFeatureMenus]);
};
